import { AdminMetricDocument, CollectionSummary } from "../services/types";

type AdminPageStateProps = {
  message: string;
};

export function LoadingState({ message }: AdminPageStateProps) {
  return (
    <section className="page-state">
      <p>{message}</p>
    </section>
  );
}

export function EmptyState({ message }: AdminPageStateProps) {
  return (
    <section className="page-state">
      <p>{message}</p>
    </section>
  );
}

export function ErrorState({ message }: AdminPageStateProps) {
  return (
    <section className="page-state error-state">
      <p>{message}</p>
    </section>
  );
}

export function SummaryCards({ summaries }: { summaries: CollectionSummary[] }) {
  return (
    <div className="card-grid">
      {summaries.map((summary) => (
        <section className="placeholder-card" key={summary.collectionName}>
          <p className="card-title">{summary.label}</p>
          <p className="card-value">{summary.count}</p>
          <p className="card-note">{summary.collectionName}</p>
        </section>
      ))}
    </div>
  );
}

export function MetricCards({ metrics }: { metrics: AdminMetricDocument[] }) {
  return (
    <div className="card-grid">
      {metrics.map((metric) => (
        <section className="placeholder-card" key={metric.id}>
          <p className="card-title">{metric.label}</p>
          <p className="card-value">
            {metric.isConfigured ? `${metric.value ?? "No value"}${metric.unit ? ` ${metric.unit}` : ""}` : "Pending"}
          </p>
          <p className="card-note">{metric.source}</p>
        </section>
      ))}
    </div>
  );
}

export function FreshnessBar({
  dataSource,
  isLive,
  lastUpdated,
  onRefresh
}: {
  dataSource: string;
  isLive: boolean;
  lastUpdated: Date | null;
  onRefresh: () => void;
}) {
  return (
    <section className="freshness-bar">
      <div>
        <span className={isLive ? "live-pill" : "source-pill"}>{isLive ? "Live" : "Snapshot"}</span>
        <span className="freshness-meta">Last Updated: {formatDateTime(lastUpdated)}</span>
        <span className="freshness-meta">Data Source: {dataSource}</span>
      </div>
      <button type="button" className="secondary-button" onClick={onRefresh}>
        Refresh
      </button>
    </section>
  );
}

export function formatDate(value: Date | null) {
  return value ? value.toLocaleDateString() : "Unknown";
}

export function formatDateTime(value: Date | null) {
  return value ? value.toLocaleString() : "Not loaded";
}
